import { apiClient, type components } from '@boothiva/api-client';

export type PlatformSettings = components['schemas']['PlatformSettingsResponse'];
export type UpdatePlatformSettingsRequest = components['schemas']['UpdatePlatformSettingsRequest'];

export const getPlatformSettings = () => apiClient.get<PlatformSettings>('/api/v1/platform/settings');
export const updatePlatformSettings = (request: UpdatePlatformSettingsRequest) =>
  apiClient.put<PlatformSettings>('/api/v1/platform/settings', request);

export type WorkerSleepState = components['schemas']['WorkerSleepStateResponse'];

export const getWorkerSleep = () => apiClient.get<WorkerSleepState>('/api/v1/platform/settings/worker');
export const setWorkerSleep = (sleeping: boolean) =>
  apiClient.put<WorkerSleepState>('/api/v1/platform/settings/worker', { sleeping });

export type MfaEnrollment = components['schemas']['MfaEnrollResponse'];
export type MfaRecoveryCodes = components['schemas']['MfaRecoveryCodesResponse'];

export const enrollMfa = () => apiClient.post<MfaEnrollment>('/api/v1/auth/mfa/enroll');
export const confirmMfaEnrollment = (code: string) => apiClient.post<MfaRecoveryCodes>('/api/v1/auth/mfa/enroll/verify', { code });
export const disableMfa = (currentPassword: string) => apiClient.post<void>('/api/v1/auth/mfa/disable', { currentPassword });
export const regenerateMfaRecoveryCodes = (code: string) => apiClient.post<MfaRecoveryCodes>('/api/v1/auth/mfa/recovery-codes/regenerate', { code });
